import Text from '@ui/text/text/text';
import CoursesSettings from '../courses/courses';
import LeaderboardSettings from '../leaderboard';

const AddOnsSettings = () => {
  return (
    <div className="flex-column gap-16">
      <div className="flex gap-4 ai-center">
        <Text className="H5" color="var(--gray-100)">
          Courses
        </Text>
      </div>
      <CoursesSettings />

      <div className="flex gap-4 ai-center">
        <Text className="H5" color="var(--gray-100)">
          User engagement
        </Text>
      </div>
      <LeaderboardSettings />
    </div>
  );
};

export default AddOnsSettings;
